import React from 'react'
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import SiteSeo from '../../components/components/seo/SiteSeo'
import { useTranslation } from 'next-i18next'
import Tabadvertising from '../../components/components/Advertising/Tabadvertising';
import KeyWordsHelper from "../../components/components/KeyWords/KeyWordsHelper"
function index() {
    const {t}=useTranslation("common")
    return (
        <div>
            <KeyWordsHelper  slugEntityClassType={null} slugEntityClass={null } url={null}/>
              <SiteSeo title={t("Advertising")}/>
            <Tabadvertising/> 
        </div>
    )
}

export default index
export async function getServerSideProps({ locale}) {


    return {
      props: {
        ...(await serverSideTranslations(locale, ["common"]))
    
      }
    }};
